import { render, staticRenderFns } from "./CaseOverview.vue?vue&type=template&id=5b987466"
import script from "./CaseOverview.vue?vue&type=script&lang=js"
export * from "./CaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports